import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZefFormComponent } from './form.component';

@NgModule({
  declarations: [ ZefFormComponent ],
  imports: [ CommonModule ],
  exports: [ ZefFormComponent ]
})
export class ZefFormModule { }
